export default "__VITE_ASSET__By1_$Qvq__"